import React from 'react';

export const Footer = () => {
    return <footer className='bg-dark mt-auto text-center text-light py-3'>Copyright</footer>;
};
